import { CREDIT_BRAND } from '@/const'

/**
 * バックエンドから返ってくるブランド名（大文字）をフロントエンドのCREDIT_BRAND型（小文字）に変換
 * @param brand バックエンドから返ってくるブランド名（"VISA", "MASTER", "JCB", "AMEX", "DINERS"）
 * @returns CREDIT_BRAND型のブランド名、またはnull
 */
export function mapBrandFromApi(brand: string | null | undefined): CREDIT_BRAND | null {
  if (!brand) return null
  const normalizedBrand = brand.toUpperCase()
  const brandMap: Record<string, CREDIT_BRAND> = {
    VISA: 'visa',
    MASTER: 'master',
    JCB: 'jcb',
    AMEX: 'amex',
    DINERS: 'diners'
  }
  return brandMap[normalizedBrand] || null
}
